/**
 * 获取pathname /之后第一个标识
 * @param pathname
 */
export default {
  getFirstPathName: (pathname?: string) => {
    const _url = pathname || location.pathname;
    return _url.split("/")[1];
  },
  /**
   * 向uri填充参数
   */
  updateQueryStringParameter: (uri, key, value) => {
    if (!value) {
      return uri;
    }
    const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    const separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
      return uri + separator + key + "=" + value;
    }
  },
  goShare: (title, detail, link, type = 0, pic?) => {
    // 去分享 type=0为全渠道 1 为qq、微信、复制链接
    window.YwkHybrid.runtime.showShareDialog({
      title,
      detail,
      link,
      type,
      pic,
    });
  },
  
  removeHtml: (text) => {
    // 移除html标签
    const reg = /<[^<>]+>/g;
     return text.replace(reg, "")
  },
};
